/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  UserReportCreate,
  UserReportRead,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    UserReportCreateFromJSON,
    UserReportCreateToJSON,
    UserReportReadFromJSON,
    UserReportReadToJSON,
} from '../models/index';

export interface CreateUserReportRequest {
    userReportCreate: UserReportCreate;
}

/**
 * 
 */
export class UserReportsApi extends runtime.BaseAPI {

    /**
     * Submit a problem report; any logged-in user. 429 once the per-user rate limit is reached.
     * Create User Report
     */
    async createUserReportRaw(requestParameters: CreateUserReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserReportRead>> {
        if (requestParameters['userReportCreate'] == null) {
            throw new runtime.RequiredError(
                'userReportCreate',
                'Required parameter "userReportCreate" was null or undefined when calling createUserReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user-reports/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserReportCreateToJSON(requestParameters['userReportCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserReportReadFromJSON(jsonValue));
    }

    /**
     * Submit a problem report; any logged-in user. 429 once the per-user rate limit is reached.
     * Create User Report
     */
    async createUserReport(requestParameters: CreateUserReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserReportRead> {
        const response = await this.createUserReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
